import React from 'react';

const Modal = ({ isOpen, onClose, children, title }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-3/4 max-w-full relative">
                <button className="absolute top-3 right-6 text-gray-500 hover:text-gray-700 text-3xl" onClick={onClose}>
                    &times;
                </button>
                {title && (
                    <h2 className="text-xl font-bold mb-4 pr-8">{title}</h2>
                )}
                {children}
            </div>
        </div>
    );
};

export default Modal;